import { hasCreditCardProcessorAtom } from "@/modules/billing/paymentProcessorsLogic.tsx";
import type { Translatable } from "@/modules/l10n/getTransText.ts";
import { Trans } from "@lingui/react/macro";
import { atom } from "jotai";

export const invoiceAddNoticeAtom = atom((get): Translatable | null => {
    if (!get(hasCreditCardProcessorAtom)) {
        return null;
    }

    return (
        <Trans>
            We recommend adding a credit card while your request is being processed to activate services right away.
        </Trans>
    );
});

export const invoiceApplyMessage = (
    <Trans>
        Please acknowledge that billing account will not be activated before an administrator has accepted your request.
    </Trans>
);
